var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2Z",
    fill: "#66B95A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2998 11H10.6998C10.1998 11 9.7998 10.6 9.7998 10.1C9.7998 9.60005 10.1998 9.20005 10.6998 9.20005H14.3998C14.9998 9.20005 15.3998 8.80005 15.3998 8.20005C15.3998 7.60005 14.9998 7.20005 14.3998 7.20005H12.9998V6.30005C12.9998 5.70005 12.5998 5.30005 11.9998 5.30005C11.3998 5.30005 10.9998 5.70005 10.9998 6.30005V7.20005H10.6998C9.0998 7.20005 7.7998 8.50005 7.7998 10.1C7.7998 11.7 9.0998 13 10.6998 13H13.1998C13.6998 13 14.0998 13.4 14.0998 13.9C14.0998 14.4 13.6998 14.8 13.1998 14.8H9.4998C8.8998 14.8 8.4998 15.2 8.4998 15.8C8.4998 16.4 8.8998 16.8 9.4998 16.8H10.9998V17.7C10.9998 18.3 11.3998 18.7 11.9998 18.7C12.5998 18.7 12.9998 18.3 12.9998 17.7V16.8H13.2998C14.8998 16.8 16.1998 15.5 16.1998 13.9C16.1998 12.3 14.8998 11 13.2998 11Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.841699771e455158f6a1139562eb9838.svg";
export { ForwardRef as ReactComponent };